import React from 'react';
import './confirm.scss';
import { Modal, Button, Heading, RadioGroup, Loader } from '../../UiKit';
import { EmptyState } from '../../components/commons';
import { InvalidSearchImg } from '../../images/images';

export const Confirm = ({
  show = false,
  isDisabled = false,
  loader = false,
  content = null,
  close = () => {},
  handleClick = () => {},
  selectOption = () => {},
}) => {
  return (
    <Modal
      isVisible={show}
      title={
        (content && content.text) ||
        'Are you sure, you want to initiate the call?'
      }
      type='medium'
      handleClose={close}
      component={
        <ConfirmComp
          content={content}
          isDisabled={isDisabled}
          handleClick={handleClick}
          selectOption={selectOption}
          loader={loader}
        />
      }
    />
  );
};

const ConfirmComp = ({
  isDisabled,
  content,
  handleClick,
  selectOption,
  loader,
}) => {
  return (
    <div className='confirm'>
      {loader ? <Loader /> : null}
      {content ? (
        <div className='col' data-dd-privacy='mask'>
          {content.messages &&
            content.messages.map((item, index) => {
              return (
                <React.Fragment key={index}>
                  {item.bgcolor ? (
                    <div
                      className='note'
                      style={{ backgroundColor: item.bgcolor }}
                    >
                      {item.image_url && (
                        <img className='popImg' src={item.image_url} alt='' />
                      )}
                      <p style={{ color: item.color }}>{item.text}</p>
                    </div>
                  ) : (
                    <p style={{ color: item.color }}>{item.text}</p>
                  )}
                </React.Fragment>
              );
            })}
          {content.radio && content.radio.source.length && (
            <React.Fragment>
              {content.radio.title && (
                <Heading title={content.radio.title.text} />
              )}
              <RadioGroup
                items={content.radio.source}
                selectOption={selectOption}
              />
            </React.Fragment>
          )}
          <div className='actions'>
            {content.buttons &&
              content.buttons.map((item, index) => {
                return (
                  <div className='cancelBtn' key={index}>
                    <Button
                      title={item.text}
                      size='compressed'
                      outline={item.action === 'cancel'}
                      color={item.color}
                      onClick={handleClick.bind(this, item.action, content)}
                      isDisabled={isDisabled}
                    />
                  </div>
                );
              })}
          </div>
        </div>
      ) : null}
      {!loader && !content ? (
        <EmptyState
          img={InvalidSearchImg}
          heading='Oooppss something went wrong!'
          isPop={true}
        />
      ) : null}
    </div>
  );
};
